/** 
 * name : taxable (ENUM STRING)
 * values : taxable / non taxable / � l'export / intracommunautaire / auto-liquidation
 *
 * name : externalCode (STRING)
 * name : escomptePercent (FLOAT)
 */

export function setTiersXtraData(
  xtraData,
  taxableValue,
  externalCodeValue,
  escomptePercentValue
) {
  // console.log("15 - xtraData=", xtraData);
  // console.log("16 - taxableValue=", taxableValue);
  // console.log("17 - externalCodeValue=", externalCodeValue);
  // console.log("18 - escomptePercentValue=", escomptePercentValue);

  const data = {
    taxable: taxableValue ? taxableValue : (xtraData ? xtraData.taxable : null),
    externalCode: externalCodeValue ? externalCodeValue : (xtraData ? xtraData.externalCode : null),
    escomptePercent: escomptePercentValue ? escomptePercentValue : (xtraData ? xtraData.escomptePercent : null)
  }
  return JSON.stringify(data, null, 2);
}

export function getTiersXtraData(
  xtraData,
) {
  const data = JSON.parse(xtraData);

  // console.log("33 - data=", data);
  return data;
}
